module.exports = __webpack_public_path__ + "static/media/terms-of-use.b09bb709.png";